export default defineNuxtPlugin(() => {
  // Les images Phone.avif et Payment.avif sont chargées avec loading="eager" et fetchpriority="high"
  // directement dans les composants, pas besoin de preload ici
  // Cela évite les warnings "preloaded but not used" dus aux animations avec délai
});
